import { Skeleton, Theme } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import clsx from 'clsx';

const useStyles = makeStyles((theme: Theme) => ({
  noDataContainer: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
  },
  barSkeleton: {
    margin: 10,
    height: 40,
    backgroundColor: theme.palette.mode === 'dark' ? 'dimgray' : 'gainsboro',
  },
  barSkeleton80: {
    width: '80%',
  },
  barSkeleton70: {
    width: '70%',
  },
  barSkeleton40: {
    width: '40%',
  },
  barSkeleton20: {
    width: '20%',
  },
}));

function OnboardingSkeleton() {
  const classes = useStyles();

  return (
    <div className={classes.noDataContainer}>
      <Skeleton
        className={clsx(classes.barSkeleton, classes.barSkeleton80)}
        variant="rectangular"
      />
      <Skeleton
        className={clsx(classes.barSkeleton, classes.barSkeleton20)}
        variant="rectangular"
      />
      <Skeleton
        className={clsx(classes.barSkeleton, classes.barSkeleton70)}
        variant="rectangular"
      />
      <Skeleton
        className={clsx(classes.barSkeleton, classes.barSkeleton70)}
        variant="rectangular"
      />
      <Skeleton
        className={clsx(classes.barSkeleton, classes.barSkeleton70)}
        variant="rectangular"
      />
      <Skeleton
        className={clsx(classes.barSkeleton, classes.barSkeleton70)}
        variant="rectangular"
      />
      <Skeleton
        className={clsx(classes.barSkeleton, classes.barSkeleton70)}
        variant="rectangular"
      />
      <Skeleton
        className={clsx(classes.barSkeleton, classes.barSkeleton70)}
        variant="rectangular"
      />
      <Skeleton
        className={clsx(classes.barSkeleton, classes.barSkeleton70)}
        variant="rectangular"
      />
      <Skeleton
        className={clsx(classes.barSkeleton, classes.barSkeleton40)}
        variant="rectangular"
      />
    </div>
  );
}

export default OnboardingSkeleton;
